module.exports = __webpack_public_path__ + "media/images/frontend/argentina-gob-ar-942a64f92a40502ea9065f5915b444b3.svg";